<template>
	<v-form
		ref="form"
		v-model="valid"
		@submit.prevent="submit"
	>
		<v-layout
			row
			wrap
			ma-0
			justify-center
			align-center
		>
			<v-flex
				py-0
				class="text-xs-left"
				:class="{ 'pr-5': $vuetify.breakpoint.smAndUp }"
			>
				<v-text-field
					v-model="name"
					:rules="[...validate.require, validate.max(name, 35), validateCheckDuplicates(name, existingProjects)]"
					:required="true"
					:autofocus="editProject ? false : true"
					name="Name"
					label="Project Name"
				/>
			</v-flex>
			<v-flex
				shrink
				class="text-xs-center"
			>
				<v-layout column>
					<v-btn
						:disabled="!valid"
						ripple
						color="primary"
						type="submit"
					>
						Submit
					</v-btn>
					<slot name="buttons"/>
				</v-layout>
			</v-flex>
		</v-layout>
	</v-form>
</template>

<script>
import Validation from '@/mixins/Validation';
import { Project } from '@/models/Project';

export default {
	mixins: [Validation],
	props: {
		editProject: { type: Object, default: null },
		existingProjects: { type: Array, default: () => [] },
	},
	data() {
		return {
			valid: true,
			name: '',
		};
	},
	created() {
		if (this.editProject) {
			this.name = this.editProject.name;
		}
	},
	methods: {
		submit() {
			if (this.editProject) {
				this.updateProject(this.editProject);
			}
			else {
				this.newProject();
			}
		},
		updateProject(project) {
			// Update Logic here
			const oldName = project.name;
			project.name = this.name;
			this.$emit('update-project', project, oldName);
		},
		newProject() {
			const project = new Project();
			project.name = this.name;
			project.isArchived = false;

			this.$emit('new-project', project);
		},
	},
};
</script>
